import React from "react";
import {
  AccessibilityProps,
  FlexStyle,
  LayoutChangeEvent,
  ShadowStyleIOS,
  StyleProp,
  TransformsStyle,
  ViewProps,
} from "react-native";

export type ResizeMode = "contain" | "cover" | "stretch" | "center";

export type Priority = "low" | "normal" | "high";

export type Cache = "immutable" | "web" | "cacheOnly";

export type Source = {
  uri?: string;
  headers?: {
    [key: string]: string;
  };
  priority?: Priority;
  cache?: Cache;
};
export interface OnLoadEvent {
  nativeEvent: {
    width: number;
    height: number;
  };
}
export interface OnProgressEvent {
  nativeEvent: {
    loaded: number;
    total: number;
  };
}
export interface ImageStyle extends FlexStyle, TransformsStyle, ShadowStyleIOS {
  backfaceVisibility?: "visible" | "hidden";
  borderBottomLeftRadius?: number;
  borderBottomRightRadius?: number;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  borderRadius?: number;
  borderTopLeftRadius?: number;
  borderTopRightRadius?: number;
  overlayColor?: string;
  tintColor?: string;
  opacity?: number;
}
export interface FastImageProps extends AccessibilityProps, ViewProps {
  source: Source | number;
  resizeMode?: ResizeMode;
  fallback?: boolean;
  onLoadStart?(): void;
  onProgress?(event: OnProgressEvent): void;
  onLoad?(event: OnLoadEvent): void;
  onError?(): void;
  onLoadEnd?(): void;
  /**
   * onLayout function
   *
   * Invoked on mount and layout changes with
   *
   * {nativeEvent: { layout: {x, y, width, height}}}.
   */
  onLayout?: (event: LayoutChangeEvent) => void;
  /**
   *
   * Style
   */
  style?: StyleProp<ImageStyle>;
  /**
   * TintColor
   *
   * If supplied, changes the color of all the non-transparent pixels to the given color.
   */
  tintColor?: number | string;
  /**
   * A unique identifier for this element to be used in UI Automation testing scripts.
   */
  testID?: string;
  /**
   * Render children within the image.
   */
  children?: React.ReactNode;
}
export interface FastImageStaticProperties {
  resizeMode: ResizeMode;
  priority: Priority;
  cacheControl: Cache;
  preload: (sources: Source[]) => void;
  clearMemoryCache: () => Promise<void>;
  clearDiskCache: () => Promise<void>;
}
